import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from "react";
export const AccordionContext = /*#__PURE__*/ createContext({
    handleAccordionChange: ()=>{}
});
export const AccordionProvider = (param)=>{
    let { children , defaultIcon  } = param;
    const [openId, setOpenId] = useState(false);
    const handleAccordionChange = useCallback((panel)=>{
        setOpenId(panel);
    }, []);
    return /*#__PURE__*/ _jsx(AccordionContext.Provider, {
        value: {
            openId,
            defaultIcon,
            handleAccordionChange
        },
        children: children
    });
};
export const useAccordion = ()=>{
    const context = useContext(AccordionContext);
    if (!context) {
        throw new Error("Missing AccordionProvider");
    }
    return context;
};
